import React from 'react';
import './ConnectionOverlay.css';

interface ConnectionOverlayProps {
  message: string;
  subtle?: boolean;
}

const ConnectionOverlay: React.FC<ConnectionOverlayProps> = ({ message, subtle = false }) => {
  return (
    <div className={`connection-overlay${subtle ? ' connection-overlay--subtle' : ''}`}>
      <div className="connection-overlay__card">
        <div className="connection-overlay__spinner" aria-hidden="true" />
        <p className="connection-overlay__message">{message}</p>
      </div>
    </div>
  );
};

export default ConnectionOverlay;
